import { Channel } from '@dev/ee-api/ee-api-models';
import {
    LoadChannelsSuccessAction,
    LoadChannelsStartAction,
    LoadChannelsErrorAction,
    ChannelsPayload,
    StatisticsChannelsState,
    ChannelsActionTypes,
} from './types';

import { ApplicationState } from '..';

export const GetChannels = (params: ChannelsPayload): LoadChannelsStartAction => ({
    type: ChannelsActionTypes.LOAD_ALL,
    payload: params,
});
export const GetChannelsSuccess = (
    channels: Channel[],
    totalCount: number,
    activePage: number,
    perPage: number
): LoadChannelsSuccessAction => ({
    type: ChannelsActionTypes.LOAD_ALL_SUCCESS,
    payload: {
        channels,
        totalCount,
        activePage,
        perPage,
        loading: false,
    },
});
export const GetChannelsError = (): LoadChannelsErrorAction => ({
    type: ChannelsActionTypes.LOAD_ALL_ERROR,
    payload: {
        loading: false,
    },
});

export const getChannelsStore = (state: ApplicationState): StatisticsChannelsState => state.channels;
